/* eslint-disable import/order */
/* eslint-disable react/prop-types */
import React, { useEffect, useCallback, useRef } from 'react';
import { Redirect } from 'react-router-dom';
import { Button } from '@fiverr-private/fit';
import { PageContainer } from '../../PageContainer';
import Social from '../../shared/Social';

import EventsReporter from '../../../utils/events/reporter';
import { COPIES } from '../../constants';
import { getPositionById } from '../../../utils/dataFunctions';
import { GTM_CUSTOM_EVENT_JOB_PAGE, trackPageEvent } from '../../../utils/events/gtm';

import { EventTypes } from '../../../utils/events/types';
import Details from './components/Details';
import Apply from './components/Apply';

import './styles.scss';
import { DEPARTMENT_KEYS, LOCATION_KEYS } from '../../../shared/comeet/comeet_api/constants';

const decodeBase64 = (encodedData) => {
    if (typeof Buffer === 'undefined') {
        return atob(encodedData);
    }

    return Buffer.from(encodedData, 'base64').toString();
};

const Job = ({ comeetPositions, match, isBlockedCountry, pageName }) => {
    const applyRef = useRef();
    const decodedJobId = decodeBase64(match?.params?.jobId),
        position = getPositionById(comeetPositions, decodedJobId);

    const city = position?.location?.city?.trim();
    const isRemotePosition = LOCATION_KEYS[city] === LOCATION_KEYS.Remote;
    const showApply = !isBlockedCountry || isRemotePosition;

    useEffect(() => {
        if (position) {
            EventsReporter.report(EventTypes.pageView, {
                pageName,
                positionName: position.name,
                positionId: decodedJobId,
            });

            trackPageEvent(GTM_CUSTOM_EVENT_JOB_PAGE);
        }
    }, [position, pageName, decodedJobId]);

    const applyClick = useCallback(() => {
        if (applyRef.current) {
            applyRef.current.scrollIntoView();
        }
    }, [applyRef]);

    if (!position) {
        return <Redirect to="/" />;
    }

    const teamName = COPIES.teams[DEPARTMENT_KEYS[position.department]] || position.department;

    return (
        <PageContainer className="jobs-page">
            <div className="side-by-side image-right">
                <div className="rich-text component_index-module__rich-text">
                    <h6>{position.name}</h6>
                    <p className="tbody-5 sub-title">
                        {teamName} | {position?.location?.name}
                    </p>
                    {showApply ? (
                        <Button className="apply-button" onClick={() => applyClick()}>
                            Apply Now
                        </Button>
                    ) : null}
                </div>
            </div>

            <div className="page-container">
                <Details details={position.details} />

                {showApply ? (
                    <>
                        <footer ref={applyRef} className="apply-block">
                            <Apply positionUid={position.uid} />
                        </footer>

                        <Social positionUid={position.uid} />
                    </>
                ) : null}
            </div>
        </PageContainer>
    );
};

export default Job;
